export default __webpack_public_path__ + "assets/images/aistudio/empty_state/5c17d00556dc2c3902ad2fee732479c6.png";